import {
  createSelector,
  createStructuredSelector,
  OutputSelector,
} from 'reselect'
import { User } from 'Types/index'
import { createDeepEqualSelector } from 'Redux/selectors/index'
import { Review } from 'Containers/Reviews/components/TrackList/props'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getState = (state: any) => state.reviews

export const getAwaitingTracksSelector: OutputSelector<
  unknown,
  Review[],
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ awaitingTracks }) => awaitingTracks)

export const getReviewedTracksSelector: OutputSelector<
  unknown,
  Review[],
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ reviewedTracks }) => reviewedTracks)

export const getMissedTracksSelector: OutputSelector<
  unknown,
  Review[],
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ missedTracks }) => missedTracks)

export const getAwaitingTracksTotalSelector: OutputSelector<
  unknown,
  number,
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ totalAwaitingTracks }) => totalAwaitingTracks
)

export const getTotalReviewedTracksSelector: OutputSelector<
  unknown,
  number,
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ totalReviewedTracks }) => totalReviewedTracks
)

export const getTotalMissedTracksSelector: OutputSelector<
  unknown,
  number,
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ totalMissedTracks }) => totalMissedTracks
)

export const getTotalAwaitingTracksSelector = createSelector(
  getState,
  ({ totalAwaitingTracks }) => totalAwaitingTracks
)

export const getTotalCancelledTracksSelector = createSelector(
  getState,
  ({ totalCancelledTracks }) => totalCancelledTracks
)

export const getCancelledTracksSelector = createSelector(
  getState,
  ({ cancelledTracks }) => cancelledTracks
)

export const getRewardPerReview = createSelector(
  getState,
  ({ rewardPerReview }) => rewardPerReview
)

export const getBlacklist = createSelector(
  getState,
  ({ wordsBlacklist }) => wordsBlacklist
)

export const getRejectReasons = createSelector(
  getState,
  ({ rejectReasons }) => rejectReasons
)

export const getReviewsLoader = createSelector(
  getState,
  ({ loading }) => loading
)

export const getCuratorStatsSelector = createSelector(
  getState,
  ({ curatorStats }) => curatorStats
)

export const getFullLibraryData = createStructuredSelector({
  getAwaitingTracksSelector,
  getReviewedTracksSelector,
  getMissedTracksSelector,
  getCancelledTracksSelector,
})
